import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
// import SponcerBanner from '../components/sponcerbanner';
import Text from '../components/text';

function TermsAndConditions() {
  const { TermsAndConditions: text } = Text;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-800 py-16 px-4">
        <div className="container mx-auto text-center max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{text.Hero.Title}</h1>
          <p className="text-xl text-blue-100">
            {text.Hero.Description}
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-xl shadow-sm p-8 border border-gray-200 mb-10">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 pb-2 border-b border-gray-200">
            {text.TermsOfService.Title}
          </h2>
          
          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Welcome.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsOfService.Welcome.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.Purpose.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsOfService.Sections.Purpose.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.Acceptance.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsOfService.Sections.Acceptance.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.Eligibility.Title}</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
              {text.TermsOfService.Sections.Eligibility.Items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.UserResponsibilities.Title}</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
              {text.TermsOfService.Sections.UserResponsibilities.Items.map((item, index) => (
                <li key={index}>
                  <strong>{item.Title}</strong> {item.Description}
                </li>
              ))}
            </ul>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.DataLimitations.Title}</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
              {text.TermsOfService.Sections.DataLimitations.Items.map((item, index) => (
                <li key={index}>
                  <strong>{item.Title}</strong> {item.Description}
                </li>
              ))}
            </ul>
          </div>

          {/* <SponcerBanner className="my-8" /> */}

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.IntellectualProperty.Title}</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
              {text.TermsOfService.Sections.IntellectualProperty.Items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.Privacy.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsOfService.Sections.Privacy.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.LimitationOfLiability.Title}</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
              {text.TermsOfService.Sections.LimitationOfLiability.Items.map((item, index) => (
                <li key={index}>
                  {item.Description}
                  {item.SubItems && (
                    <ul className="list-circle pl-6 mt-2 space-y-1">
                      {item.SubItems.map((subItem, subIndex) => (
                        <li key={subIndex}>{subItem}</li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.Termination.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsOfService.Sections.Termination.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.ContactUs.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsOfService.Sections.ContactUs.Description}
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsOfService.Sections.LastUpdated.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsOfService.Sections.LastUpdated.Date}
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm p-8 border border-gray-200 mb-10">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 pb-2 border-b border-gray-200">
            {text.TermsAndConditionsSection.Title}
          </h2>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.Introduction.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsAndConditionsSection.Sections.Introduction.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.UseOfWebsite.Title}</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
              {text.TermsAndConditionsSection.Sections.UseOfWebsite.Items.map((item, index) => (
                <li key={index}>
                  <strong>{item.Title}</strong> {item.Description}
                  {item.SubItems && (
                    <ul className="list-circle pl-6 mt-2 space-y-1">
                      {item.SubItems.map((subItem, subIndex) => (
                        <li key={subIndex}>{subItem}</li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.ServiceDescription.Title}</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
              {text.TermsAndConditionsSection.Sections.ServiceDescription.Items.map((item, index) => (
                <li key={index}>
                  <strong>{item.Title}</strong> {item.Description}
                </li>
              ))}
            </ul>
          </div>

          {/* <SponcerBanner className="my-8" /> */}

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.UserGeneratedContent.Title}</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
              {text.TermsAndConditionsSection.Sections.UserGeneratedContent.Items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.ThirdPartyLinks.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsAndConditionsSection.Sections.ThirdPartyLinks.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.FeesAndPayments.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsAndConditionsSection.Sections.FeesAndPayments.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.Disclaimers.Title}</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
              {text.TermsAndConditionsSection.Sections.Disclaimers.Items.map((item, index) => (
                <li key={index}>
                  <strong>{item.Title}</strong> {item.Description}
                </li>
              ))}
            </ul>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.Indemnity.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsAndConditionsSection.Sections.Indemnity.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.GoverningLaw.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsAndConditionsSection.Sections.GoverningLaw.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.ChangesToTerms.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsAndConditionsSection.Sections.ChangesToTerms.Description}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.ContactInformation.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsAndConditionsSection.Sections.ContactInformation.Description}
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">{text.TermsAndConditionsSection.Sections.EffectiveDate.Title}</h3>
            <p className="text-gray-700 mb-4">
              {text.TermsAndConditionsSection.Sections.EffectiveDate.Date}
            </p>
          </div>
        </div>

        <div className="text-center mt-10">
          <Link to="/" className="inline-block bg-blue-600 text-white hover:bg-blue-700 font-medium px-6 py-3 rounded-lg transition-colors">
            {text.ReturnToHome}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;